import { NetworkStatus } from '@apollo/client';
import { QueryStatus } from 'v2/core/repository/edge-server/types';

export const apolloStatusToQueryStatus = (
  loading: boolean,
  called: boolean,
  skip?: boolean,
  error?: Error,
  networkStatus?: NetworkStatus,
): QueryStatus => {
  if (!called || skip) {
    return QueryStatus.NOT_CALLED;
  }
  if (networkStatus === NetworkStatus.refetch) {
    return QueryStatus.REFETCHING;
  }
  if (loading) {
    return QueryStatus.IN_PROGRESS;
  }
  if (error) {
    return QueryStatus.ERROR_COMPLETED;
  }
  return QueryStatus.SUCCESS_COMPLETED;
};
